export default __webpack_public_path__ + "static/RootSans-10BoldItalic-3db0e31291ac8ff589218c33fe446bc6.woff2";